import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { calibrationService } from '../services/calibration';

export const useCalibrations = (sensorId?: string) => {
  return useQuery({
    queryKey: ['calibrations', sensorId],
    queryFn: () =>
      sensorId
        ? calibrationService.getCalibrations(sensorId)
        : calibrationService.getAllCalibrations(),
    enabled: Boolean(sensorId),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useCreateCalibration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: calibrationService.createCalibration,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['calibrations'] });
      toast.success(`Seřízení ${variables.type} čidla bylo úspěšně uloženo`);
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Chyba při ukládání seřízení');
    },
  });
};

export const useDeleteCalibration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: calibrationService.deleteCalibration,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['calibrations'] });
      toast.success('Seřízení smazáno');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Chyba při mazání seřízení');
    },
  });
};
